<template>
  <div class="dg-pausable">
    <div class="dg-content-body">
      <template v-if="messageHasTitle">
        <h2 v-if="options.html" class="dg-title" v-html="messageTitle"></h2>
        <h2 v-else class="dg-title">{{ messageTitle }}</h2>
      </template>

      <div v-if="options.html" class="dg-content" v-html="messageBody"></div>
      <div v-else class="dg-content">{{ messageBody }}</div>
    </div>

    <div class="dg-content-footer">
      <button class="dg-btn dg-btn--cancel" @click="handleDismiss">
        <span>Cancel</span>
      </button>
      <button class="dg-btn dg-btn--ok dg-pull-right" @click="handleProceed">
        <span class="dg-btn-content">
          <span>Proceed</span>
        </span>
      </button>
      <div class="dg-clear"></div>
    </div>

    <div class="mt-2 text-center">
      <b-form-checkbox
        v-model="pause"
        @change="val => {
      }"
        label
      >Disable this prompt for 30 days</b-form-checkbox>
    </div>
  </div>
</template>

<script>
import DialogMixin from "vuejs-dialog/dist/vuejs-dialog-mixin.min.js";
import hash from "object-hash";

export default {
  mixins: [DialogMixin],
  data() {
    return {
      pause: false
    };
  },
  created() {
    if (Cookies.get(hash(this.messageBody))) {
      this.proceed();
    }
  },
  methods: {
    handleProceed() {
      if (this.pause) {
        Cookies.set(hash(this.messageBody), 1, { expires: 30 });
      }

      this.proceed(); // included in DialogMixin
    },
    handleDismiss() {
      this.cancel(); // included in DialogMixin
    }
  },
  components: {}
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Dialogs/Pausable.vue